import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import SearchIcon from '@material-ui/icons/Search';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { CircularProgress } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4';

const styles = (theme) => ({
  root: {
    position: 'relative',
  },
  icon: {
    transform: 'scale(0.75)',
    fill: theme.palette.facet.darkGray,
  },
  iconSearching: {},
  progress: {
    position: 'absolute',
    left: 0,
    color: theme.palette.facet.darkGray,
  },
});

const SearchIconLoader = ({
  className,
  classes,
  isSearching,
}) => {
  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <SearchIcon
        className={classNames(classes.icon, {
          [classes.iconSearching]: isSearching,
        })}
      />
      {isSearching ? (
        <CircularProgress
          className={classNames(classes.progress)}
          size={24}
        />
      ) : null}
    </Box>
  );
};

SearchIconLoader.defaultProps = {
  className: '',
};

SearchIconLoader.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  isSearching: PropTypes.bool.isRequired,
};

export default withStyles(styles)(SearchIconLoader);
